import { render, staticRenderFns } from "./PrintableOutpatientAuditReport.vue?vue&type=template&id=b98dafba&scoped=true&"
import script from "./PrintableOutpatientAuditReport.vue?vue&type=script&lang=js&"
export * from "./PrintableOutpatientAuditReport.vue?vue&type=script&lang=js&"
import style0 from "./PrintableOutpatientAuditReport.vue?vue&type=style&index=0&id=b98dafba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b98dafba",
  null
  
)

export default component.exports